<template>
    <b-badge v-if="!row.IsIgnored" variant="dark">Yasaklı Değil</b-badge>
    <b-badge v-else variant="danger">Yasaklı</b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue';

export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    }
}
</script>

<style>

</style>